import { createFileRoute } from "@tanstack/react-router";
import { ConnectionsList, type ConnectionsSearch } from "../../../features/connections/connections-list";
import { isConnectionType } from "../../../features/connections/model";

export const Route = createFileRoute("/_authed/$org/$project/connections/")({
  validateSearch: (s: Record<string, unknown>): ConnectionsSearch => ({
    ...(isConnectionType(s.type) ? { type: s.type } : {}),
    ...(typeof s.q === "string" && s.q ? { q: s.q } : {}),
  }),
  component: ConnectionsPage,
});

function ConnectionsPage() {
  const { org, project } = Route.useParams();
  return <ConnectionsList scope={{ org, project }} search={Route.useSearch()} />;
}
